import React from 'react'

const Switch = ({ checked, onChange, disabled, className = '' }) => {
    return (
        <label className={`relative inline-flex items-center cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
            <input 
                type="checkbox" 
                className="sr-only peer" 
                checked={checked} 
                onChange={disabled ? undefined : (e) => onChange(e.target.checked)}
                disabled={disabled}
            />
            <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary/30 dark:peer-focus:ring-primary/50 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary`}></div>
        </label>
    )
}

export default Switch
